import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import NavigationBar from '../../components/ui/NavigationBar';
import HeroSection from '../home-landing-page/components/HeroSection';

const ForIndividuals = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>For Individuals | Nesolearn</title>
        <meta
          name="description"
          content="Learn, build, and earn with Nesolearn, for individuals ready to grow their skills."
        />
        <link rel="canonical" href="/for-individuals" />
      </Helmet>

      <div className="min-h-screen bg-background">
                <NavigationBar onDark />
        <main>
          <HeroSection />
        </main>
      </div>
    </>
  );
};

export default ForIndividuals;